import React from 'react'

/**
 * Input — standard single-line text field. Thin border, blue focus halo.
 * For numbers pass type="number" (native spinners are hidden by the theme).
 */
export function Input({ className = '', type = 'text', ...rest }) {
  return <input type={type} className={className} {...rest} />
}
